import { app } from '../../../app';
import { Controller } from './resources.controller';

app.component('companyResources', {
    bindings: {
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./resources.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/resources/resources.component.js